import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import ModalBase from '../ModalBase';
import { Portal } from '../../portal/Portal';
export const useModal = (onModalClose, isOpenByDefault = false, canCloseViaLayer = true, defaultLeftSpace = 0) => {
    const [isOpen, setIsOpen] = useState(isOpenByDefault);
    const closeModal = useCallback(() => {
        setIsOpen(false);
        if (onModalClose)
            onModalClose();
    }, [onModalClose]);
    const openModal = useCallback(() => {
        setIsOpen(true);
    }, []);
    const Dialog = useCallback(({ title, titleIcon, description, step, children, testId, leftSpace = defaultLeftSpace, onHeaderButtonClick, headerButtonText, shouldHideHeaderBorder = false, headerBackground, }) => (_jsx(Portal, { children: _jsx(ModalBase, { step: step, title: title, titleIcon: titleIcon, isOpen: isOpen, testId: testId, onClose: closeModal, leftSpace: leftSpace, description: description, canCloseViaLayer: canCloseViaLayer, onHeaderButtonClick: onHeaderButtonClick, headerButtonText: headerButtonText, shouldHideHeaderBorder: shouldHideHeaderBorder, headerBackground: headerBackground, children: children }) })), [defaultLeftSpace, isOpen, closeModal, canCloseViaLayer]);
    return {
        Dialog,
        openModal,
        closeModal,
        isOpen,
    };
};
//# sourceMappingURL=useModal.js.map